export const support_page = {
  title: "Support",
  section_help_title: "How can we help?",
  intro:
    "Having trouble with the app? Need to connect with our customer service team?",
  instructions:
    "Please fill out the form below to e-mail us, and we'll get back to you as soon as possible.",
  field_feedback_type: "Type of Feedback",
  field_subject: "Subject",
  field_message: "Message",
  submit: "Submit Message",
  back_to_account_aria: "Back to account",
  submit_success: "Your message was sent. We'll get back to you soon.",
  submit_error: "We could not send your message. Please try again.",
  feedback_bug: "Bug report",
  feedback_feature: "Feature request",
  feedback_account: "Account & billing",
  feedback_other: "Other",
};
